import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Typography } from '@nutrien/cxp-components';
import React, { useState } from 'react';

import { useDeficiencyList } from '../../rxdb/deficiencyList/useDeficiencyList';

interface Props {
  open: boolean;
  onClose: () => void;
  componentVersionUUID: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    dialogActionGridContainer: { padding: 5 },
    deleteGrid: { padding: '25px 0px 25px 0px' },
    deleteText: { width: '100%', letterSpacing: '0.15px' },
  }),
);

const DeleteDeficiency: React.FC<Props> = ({ open, onClose, componentVersionUUID }) => {
  const { deleteDeficiency } = useDeficiencyList();
  const classes = useStyles();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const confirmDelete = async () => {
    if (!isDeleting) {
      setIsDeleting(true);
      await deleteDeficiency(componentVersionUUID);
      setIsDeleting(false);
      onClose();
    }
  };

  return (
    <Dialog
      data-testid="delete-deficiency-dialog"
      onClose={onClose}
      open={open}
      titleText="Delete Deficiency"
      backButton={false}
      dialogActions={
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          className={classes.dialogActionGridContainer}
        >
          <Grid item>
            <Button
              noMinHeight
              color="error"
              variant="contained"
              onClick={confirmDelete}
              isLoading={isDeleting}
            >
              Yes, Delete
            </Button>
          </Grid>
        </Grid>
      }
      maxWidth="xs"
      noMinHeight
    >
      <Grid container className={classes.deleteGrid}>
        <Grid item container xs={12} alignItems="center">
          <Typography variant="h6" className={classes.deleteText}>
            Are you sure want to delete the deficiency from this inspection?
          </Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default DeleteDeficiency;
